import classNames from "classnames/bind";
import styles from './TablePlate.module.css';
import { Table } from "../../../../../../components";
import { useContext } from "react";
import { LisencePlateContext } from "../../../../../../contexts";
import { formatDDMMYY, formatDateToTime } from "../../../../../../utils";

const cx = classNames.bind(styles);

const TablePlate = ({data}) => {
    const { screen,info,setShowInfo,showInfo,setInfo } = useContext(LisencePlateContext)
    // const data = [];
    // for (let index = 0; index < 30; index++) {
    //     const element = {
    //         id: index,
    //         license: '36A - 618.23',
    //         time: <div className={cx('align_right')}>{'16:30:30 - 17/02/2023'}</div>,
    //     };
    //     data.push(element)
    // }
    const list = data.map((item,index)=>{
        return {
            stt: index+1,
            license: item.LICENSE_PLATE,
            time: <div className={cx('align_right')}>{`${formatDateToTime(item?.TIME)}`}</div>,
            camera_image:item.CAMERA_IMAGE,
            plate_image:item.LICENSE_PLATE_IMAGE,
        }
    })
    const col = [
        {
            label: "Biển số",
            key: "license",
        },
        {
            label: <div className={cx('align_right')}>{"Thời gian"}</div>,
            key: "time",
        },
    ]
    return (
        <div className={cx('container')}>
            <div className={cx('table', screen.total === 2 ? 'small-height' : '')}>
                <Table colum={col} info={info} data={list} onClick={(item) => {
                    setInfo(item)
                    setShowInfo(true)
                }} />
            </div>
        </div>
    )
}

export default TablePlate